import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// import DatePicker from "react-multi-date-picker";
import { Search, Plus, Trash2, SearchIcon } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// Formik
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import { DateObject } from "react-multi-date-picker";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import { useDispatch } from "react-redux";

import FactoryWasteColumn from "Common/Components/ColumnData/FactoryWasteColumn";
import {
  addFactoryWaste,
  deleteFactoryWaste,
} from "slices/FactoryWaste/reducer";

const FactoryWaste = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [datafactoryID, setDataFactoryID] = useState<any>();
  const [datfactoryList, setdatfactoryList] = useState<any>([]);
  const [Datevalues, setDatevaluesValues] = useState<DateObject | null>(
    new DateObject({ calendar: persian }).setLocale(persian_fa)
  );
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const dispatch = useDispatch<any>();
  const [isLoadingBtn, setisLoadingBtn] = useState<any>();
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;

    const totalItems = alldata ? Number(alldata) : 0;
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize);
    setCurrentPage(newPage);

    fetchData(newPage, newSize);
  };
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  const localstorageID = localStorage.getItem("crop_year_id");
  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == localstorageID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);
  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, size, reload, searchValue ? searchValue : null]);

  const fetchData = async (page: any, size: any) => {
    try {
      const CropYearID = localStorage.getItem("crop_year_id");
      let url = `https://api.havirkesht.ir/factory_waste/?sort_by=updated_at&sort_order=desc&crop_year_id=${CropYearID}&size=${size}&page=${page}&crop_year_id=${CropYearID}`;
      if (searchValue && searchValue.trim() !== "") {
        url += `&search=${encodeURIComponent(searchValue.trim())}`;
      }
      const res: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });
      const items = res?.data?.items || [];
      setData(items);
      setalldata(res?.data?.total);
      setTotalPages(res?.data?.pages);
      setload(items.length < 1); // اصلاح شده به <1 به جای <0
    } catch (error: any) {
      console.error("Error fetching data:", error);
      setErrorMessage(
        error.response
          ? "خطایی رخ داده است. لطفاً مجدداً تلاش کنید."
          : "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
      );
      setload(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/factory/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdatfactoryList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, []);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (!eventData) return; // اگر eventData وجود نداشت، از تابع خارج شو

    try {
      const result = await dispatch(deleteFactoryWaste(eventData));
      if (result.payload?.dataID) {
        Swal.fire({
          title: "حذف تفاله  کارخانه",
          text: "عملیات حذف با موفقیت انجام شد",
          icon: "success",
        });
        setreload(!reload);
      } else {
        Swal.fire({
          title: "حذف تفاله  کارخانه",
          text: "خطا در حذف دیتا",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error in delete operation:", error);
      toast.error("خطای سرور در حذف داده");
    } finally {
      setDeleteModal(false);
      setEventData(null);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      waste_weight_received_factory: "", // Added for weight
      waste_price_received_factory: "", // Changed from 'price'
    },
    validationSchema: Yup.object({
      waste_weight_received_factory: Yup.number()
        .typeError("وزن باید عددی باشد")
        .required("لطفاً وزن را وارد کنید"),
      waste_price_received_factory: Yup.number()
        .typeError("مبلغ باید عددی باشد")
        .required("لطفاً مبلغ را وارد کنید"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (!localStorage.getItem("crop_year_id")) {
        return toast.error("لطفاً سال زراعی را انتخاب کنید");
      }
      if (!datafactoryID) {
        return toast.error("لطفاً کارخانه را انتخاب کنید");
      }

      setisLoadingBtn(true);
      const newdata = {
        factory_id: Number(datafactoryID),
        waste_weight_received_factory: Number(
          values.waste_weight_received_factory
        ),
        waste_price_received_factory: Number(
          values.waste_price_received_factory
        ),
        crop_year_id: Number(localStorage.getItem("crop_year_id")),
      };

      try {
        dispatch(addFactoryWaste(newdata)).then((result: any) => {
          if (result.payload.id) {
            Swal.fire({
              title: "ثبت تفاله کارخانه",
              text: "اطلاعات تفاله کارخانه با موفقیت ثبت شد",
              icon: "success",
            });
            setisLoadingBtn(false);
            setreload(!reload);
            resetForm();
          } else {
            Swal.fire({
              title: "ثبت تفاله کارخانه",
              text: "خطا در ثبت اطلاعات. لطفاً مجدداً تلاش کنید",
              icon: "error",
            });
          }
        });
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("خطا در ثبت اطلاعات. لطفاً مجدداً تلاش کنید");
        setisLoadingBtn(false);
      } finally {
        toggle();
      }
    },
  });
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = FactoryWasteColumn({ onClickDelete });
  const formatNumber = (num: number | string) => {
    if (num === null || num === undefined || num === "") return "";
    const numStr = num.toString()?.replace(/,/g, "");
    return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum?.replace(/,/g, "");
  };
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت کارخانه" title="هاویر کشت" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex flex-col sm:flex-row items-center gap-3 mb-4">
            <h6 className="text-15 grow sm:w-auto">
              مجموع تفاله کارخانه ها (
              <b className="total-Employs">{alldata?.toString()}</b>)
              <label className="flex flex-col sm:flex-row gap-2 mt-4 items-center">
                <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute inset-y-0 left-2 flex items-center text-gray-400">
                    <SearchIcon />
                  </span>
                </div>
              </label>
            </h6>

            <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto gap-3 md:py-0 py-2">
              <div className="w-full sm:w-auto">
                <TableDropDownSmall onSelect={handleSelect} />
              </div>

              <div className="shrink-0 w-full sm:w-auto">
                <Link
                  to="#"
                  onClick={toggle}
                  type="button"
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 w-full sm:w-auto block text-center"
                >
                  <span className="align-middle rtl">ایجاد تفاله کارخانه</span>{" "}
                  <Plus className="inline-block size-4 rtl" />
                </Link>
              </div>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              data={data}
              customPageSize={selectedNumber}
              isGlobalFilter={false}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16">
            ایجاد تفاله کارخانه جدید
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 mr-6 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
                {/* Factory selection */}
                <div className="flex flex-col">
                  <label
                    htmlFor="factory"
                    className="text-base font-medium mb-1"
                  >
                    کارخانه:
                  </label>
                  <select
                    id="factory"
                    className="p-2 border rounded bg-white text-gray-900 dark:border-gray-600 w-full"
                    value={datafactoryID}
                    onChange={(e) => setDataFactoryID(e.target.value)}
                    required
                  >
                    <option value="" hidden>
                      انتخاب کنید
                    </option>
                    {datfactoryList?.map((data: any) => (
                      <option key={data.id} value={data.id}>
                        {data.factory_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Sugar weight received */}
                <div className="flex flex-col">
                  <label
                    htmlFor="sugar_weight"
                    className="text-base font-medium mb-1"
                  >
                    وزن تفاله دریافتی از کارخانه:
                  </label>
                  <input
                    type="text" // تغییر به text برای کنترل بهتر فرمت
                    id="sugar_weight"
                    className="form-input text-black font-[12px] w-full"
                    placeholder="وزن تفاله دریافتی را وارد کنید"
                    name="waste_weight_received_factory"
                    autoComplete="off"
                    onChange={(e) => {
                      const rawValue = parseFormattedNumber(e.target.value);

                      // اعتبارسنجی - فقط اعداد صحیح غیرمنفی
                      if (rawValue === "" || /^\d+$/.test(rawValue)) {
                        validation.setFieldValue(
                          "waste_weight_received_factory",
                          rawValue === "" ? "" : parseInt(rawValue, 10)
                        );
                      }
                    }}
                    value={formatNumber(
                      validation.values.waste_weight_received_factory
                    )}
                    onKeyDown={(e) => {
                      // فقط اجازه ورود اعداد و کلیدهای کنترل
                      if (
                        !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                          e.key
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                    inputMode="numeric" // نمایش کیبورد عددی در موبایل
                  />
                  {validation.touched.waste_weight_received_factory &&
                    validation.errors.waste_weight_received_factory && (
                      <p className="text-red-400 mt-1">
                        {validation.errors.waste_weight_received_factory}
                      </p>
                    )}
                </div>

                {/* Sugar price received */}
                <div className="flex flex-col">
                  <label
                    htmlFor="sugar_price"
                    className="text-base font-medium mb-1"
                  >
                    بهای تفاله دریافتی از کارخانه:
                  </label>
                         <input
                    type="text" // تغییر به text برای کنترل بهتر فرمت
                    id="waste_price_received_factory"
                    className="form-input text-black font-[12px] w-full"
                    placeholder="وزن تفاله دریافتی را وارد کنید"
                    name="waste_price_received_factory"
                    autoComplete="off"
                    onChange={(e) => {
                      const rawValue = parseFormattedNumber(e.target.value);

                      // اعتبارسنجی - فقط اعداد صحیح غیرمنفی
                      if (rawValue === "" || /^\d+$/.test(rawValue)) {
                        validation.setFieldValue(
                          "waste_price_received_factory",
                          rawValue === "" ? "" : parseInt(rawValue, 10)
                        );
                      }
                    }}
                    value={formatNumber(
                      validation.values.waste_price_received_factory
                    )}
                    onKeyDown={(e) => {
                      // فقط اجازه ورود اعداد و کلیدهای کنترل
                      if (
                        !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(
                          e.key
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                    inputMode="numeric" // نمایش کیبورد عددی در موبایل
                  />
                 
                  {validation.touched.waste_price_received_factory &&
                    validation.errors.waste_price_received_factory && (
                      <p className="text-red-400 mt-1">
                        {validation.errors.waste_price_received_factory}
                      </p>
                    )}
                </div>

                <div className="">
                  سال زراعی انتخاب شده:{" "}
                  <span className="text-custom-600 dark:text-gray-200 bold">
                    {YearCoptSelect ? YearCoptSelect : ""}{" "}
                  </span>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            {isLoadingBtn ? "در حال ارسال..." : "ثبت اطلاعات"}{" "}
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default FactoryWaste;
